import {
  FullScreenError,
  FullScreenSpinner,
} from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';
import { useGetPaginatedGroups } from 'api/organisationGroups/useGetPaginatedGroups';
import { Search, useSearch } from 'api/search';
import TabLayout from './TabLayout';

const GroupsTab = () => {
  const { t } = useTranslation();
  const { searchTerm, searchString, setSearchString }: Search = useSearch();
  const { status, isFetching, hasMore, loadMore, paginator } =
    useGetPaginatedGroups(searchTerm);

  if (status === 'pending') {
    return <FullScreenSpinner message={t('ui.event-management.loading')} />;
  }
  if (status === 'error') {
    return (
      <FullScreenError
        message={t('ui.event-management.organisations.error-loading')}
      />
    );
  }

  const heading = searchTerm
    ? t('ui.event-management.organisations.tab.subtitle.after.search.groups')
    : t('ui.event-management.organisations.tab.subtitle.before.search.groups');

  const searchProps = {
    labelText: `${t(
      'ui.event-management.organisations.tab.search.box.label.prefix',
    )} ${t('ui.event-management.organisations.tab.search.box.label.groups')}`,
    placeholder: t(
      'ui.event-management.organisations.tab.search.box.placeholder.text',
    ),
    inputState: searchString,
    handleTermChange: setSearchString,
  };
  const apiPaginationProps = {
    isFetching,
    hasMoreToLoad: hasMore,
    loadMore,
    loadingState: status,
  };
  return (
    <TabLayout
      heading={heading}
      searchProps={searchProps}
      paginator={paginator}
      apiPaginationProps={apiPaginationProps}
      organisationsOrGroups={paginator.pagedItems}
    />
  );
};

export default GroupsTab;
